import React from 'react';

const MembershipPlanUserFormModal = React.lazy(() => import('../components/FormModal'));
const membershipPlanUserModalRegistry = {
    core_membershipPlanUserId: MembershipPlanUserFormModal
};
export default membershipPlanUserModalRegistry;
